import { Button } from '@/components/ui/button'
import { downloadAllInvoicesOrganizationOrganizationIdDownloadAllInvoicesGetOptions } from '@/generated/@tanstack/react-query.gen'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useUser } from '../../user-provider'
import Spinner from '@/components/Spinner'
import { toast } from '@/components/custom-toast'

interface Props {
  show: boolean
}

export default function DownloadAll({ show }: Props) {
  const { organizationId } = useUser()
  const [exporting, setExporting] = useState(false)

  const queryClient = useQueryClient()

  const handleExport = async () => {
    setExporting(true)

    await queryClient
      .fetchQuery({
        ...downloadAllInvoicesOrganizationOrganizationIdDownloadAllInvoicesGetOptions(
          {
            path: {
              organization_id: organizationId,
            },
            query: {},
          }
        ),
      })
      .then((data: any) => {
        const blob = new Blob([data as string], {
          type: 'application/zip',
        })

        const fileName = `all_invoices.zip`
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = url
        a.download = fileName
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        toast.success({
          title: 'Success',
          message: `All invoices have been downloaded successfully.`,
        })
      })
      .catch((error) => {
        toast.error({
          title: 'Error',
          message:
            (error.response?.data.detail as unknown as string) ?? error.message,
        })
      })
      .finally(() => {
        setExporting(false)
      })
  }

  if (!show) return <div className="h-12" />
  return (
    <div className="mb-4">
      <Button
        onClick={() => handleExport()}
        variant="ghost"
        size={'sm'}
        className="flex text-base items-center text-primary gap-2 px-0 font-medium"
      >
        <IconDownload />
        Download All Invoices
      </Button>
      {exporting && <Spinner />}
    </div>
  )
}
const IconDownload = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3333 10.6667V12C11.3333 12.3536 11.1929 12.6928 10.9428 12.9428C10.6928 13.1929 10.3536 13.3333 10 13.3333H3.33333C2.97971 13.3333 2.64057 13.1929 2.39052 12.9428C2.14048 12.6928 2 12.3536 2 12V7.33333C2 6.97971 2.14048 6.64057 2.39052 6.39052C2.64057 6.14048 2.97971 6 3.33333 6H4.66667M6.66667 3.33333H6C5.64638 3.33333 5.30724 3.47381 5.05719 3.72386C4.80714 3.97391 4.66667 4.31304 4.66667 4.66667V9.33333C4.66667 9.68696 4.80714 10.0261 5.05719 10.2761C5.30724 10.5262 5.64638 10.6667 6 10.6667H12.6667C13.0203 10.6667 13.3594 10.5262 13.6095 10.2761C13.8595 10.0261 14 9.68696 14 9.33333V4.66667C14 4.31304 13.8595 3.97391 13.6095 3.72386C13.3594 3.47381 13.0203 3.33333 12.6667 3.33333H12M11.3333 6L9.33333 8M9.33333 8L7.33333 6M9.33333 8V2"
        stroke="#00B69B"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </svg>
)
